export const SUBSCRIPTION_SHIPPING_TYPE = 'subscription-shipping';

export const nameForShippingMethod = (name?: string | null | undefined) => {
  if (name === 'pickup') return 'Pickup from True Green Health Dispensary, Newtown NSW';
  if (name === 'pickup-newtowndispensary') return 'Pickup from True Green Health Dispensary, Newtown NSW';
  if (name === 'pickup-strathpinedispensary') return 'Pickup from True Green Health Dispensary, Strathpine QLD';
  if (name === 'sameday-newtown') return 'Same day delivery NSW';
  if (name === 'sameday-strathpine') return 'Same day delivery QLD';
  if (name === 'CouriersPlease') return 'Couriers Please';
  if (name === 'TntOvernightExpress') return 'TNT Courier';
  if (name === 'MyPostBusinessExpress') return 'Australia Post';
  if (name === 'StarTrackPremium') return 'StarTrack Premium';``
  if (name === SUBSCRIPTION_SHIPPING_TYPE) return 'Auto Refill Shipping via StarTrack Premium';

  return name;
};

export const iconForShippingMethod = (name?: string | null | undefined) => {
  if (name === 'CouriersPlease') return require('./couriers_please.svg');
  if (name === 'TntOvernightExpress') return require('./tnt.svg');
  if (name === 'MyPostBusinessExpress') return require('./my_post_business_express.svg');
  if (name === 'StarTrackPremium') return require('./star_track_premium.svg');

  return null;
};
